import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <rect x="3" y="4" width="3" height="15" fill="black" fillOpacity="0.6" />
      <path d="M16 7V16H19V4L14 5V7H16Z" fill="black" fillOpacity="0.6" />
      <rect x="9" y="4" width="3" height="15" fill="black" fillOpacity="0.6" />
      <rect x="6" y="10" width="3" height="3" fill="black" fillOpacity="0.6" />
      <rect
        x="14"
        y="16"
        width="7"
        height="3"
        fill="black"
        fillOpacity="0.6"
      />{' '}
    </>
  ),
  'Heading 1',
  '0 0 24 24'
);
